import React from "react";

import { Box, CardActionArea, CardMedia, FormHelperText, Paper, PaperProps, Typography } from "@material-ui/core";
import clsx from "clsx";

import MenuItem from "api/types/MenuItem";
import makeStyles from "hooks/makeStyles";
import useFormatMoney from "hooks/useFormatMoney";
import useLocalize from "hooks/useLocalize";
import useTranslation from "hooks/useTranslation";

const useStyles = makeStyles(theme => {
	return {
		root: {
			marginTop: 0,
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			marginBottom: theme.spacing(1),
			backgroundColor: theme.palette.background.default,
			borderRadius: 4
		},
		actionArea: {
			boxSizing: "border-box",
			borderRadius: 4,
			minHeight: 72,
			position: "relative",
			boxShadow: "1px 1px 4px 1px rgba(64, 64, 64, 0.1)"
		},
		itemBody: {
			display: "flex",
			flex: 1,
			flexDirection: "column",
			justifyContent: "space-between",
			minHeight: 72,
			margin: 0,
			padding: theme.spacing(2)
		},
		title: {
			fontWeight: 600,
			fontSize: 16,
			color: "#30323b",
			alignSelf: "left"
		},
		desc: {
			fontSize: 14,
			fontWeight: 400,
			color: "#646464",
			maxWidth: "100%",
			display: "-webkit-box",
			WebkitBoxOrient: "vertical",
			WebkitLineClamp: 2,
			overflow: "hidden",
			textOverflow: "ellipsis"
		},
		price: {
			fontWeight: 500,
			fontSize: 14,
			color: "#4f4f4f",
			alignSelf: "left",
			paddingTop: theme.spacing(2)
		},
		imageContainer: {
			width: "100%",
			height: "240px"
		},
		imageCard: {
			height: "100%",
			borderTopLeftRadius: 4,
			borderTopRightRadius: 4
		},
		code: {
			position: "absolute",
			bottom: 10,
			right: 10,
			fontSize: 14
		},
		outOfStock: {
			color: "#4f4f4f",
			textTransform: "capitalize"
		}
	};
});

interface Props extends PaperProps {
	item: MenuItem;
}

const MenuItemCardMobile = ({ className, item, ...otherProps }: Props) => {
	const { formatMoney } = useFormatMoney();
	const { localize } = useLocalize();
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<Paper className={clsx(classes.root, className)} elevation={0} {...otherProps}>
			<CardActionArea component="a" className={classes.actionArea} href={`#item:${item.id}`}>
				{item.imageUrl && (
					<Box className={classes.imageContainer}>
						<CardMedia image={item.imageUrl} className={classes.imageCard}></CardMedia>
					</Box>
				)}
				<Box className={classes.itemBody}>
					{item.outOfStock && <FormHelperText className={classes.outOfStock}>{t("-outOfStock-")}</FormHelperText>}
					<Typography className={classes.title}>{localize(item.localeNames, item.name)}</Typography>
					<Typography className={classes.desc}>{item.description}</Typography>
					<Typography className={classes.price}>{formatMoney(item)}</Typography>
				</Box>
			</CardActionArea>
		</Paper>
	);
};

export default MenuItemCardMobile;
